import "../../css/SupportFilters.css";

function SupportFilters({
    filters,
    onChange,
}) {

    return (

        <div className="support-filters">

            <input
                type="text"
                placeholder="Search Ticket..."
                value={filters.search}
                onChange={(e) =>
                    onChange("search", e.target.value)
                }
            />

            <select
                value={filters.status}
                onChange={(e) =>
                    onChange("status", e.target.value)
                }
            >

                <option value="">All Status</option>
                <option value="Open">Open</option>
                <option value="In Progress">In Progress</option>
                <option value="Resolved">Resolved</option>
                <option value="Closed">Closed</option>

            </select>

            <select
                value={filters.priority}
                onChange={(e) =>
                    onChange("priority", e.target.value)
                }
            >

                <option value="">All Priority</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Urgent">Urgent</option>

            </select>

            <select
                value={filters.category}
                onChange={(e) =>
                    onChange("category", e.target.value)
                }
            >

                <option value="">All Category</option>
                <option value="Payment">Payment</option>
                <option value="Order">Order</option>
                <option value="Delivery">Delivery</option>
                <option value="Account">Account</option>
                <option value="Other">Other</option>

            </select>

        </div>

    );

}

export default SupportFilters;